import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardBody, CardHeader } from '@/components/ui/Card';
import { Table } from '@/components/ui/Table';
import { cn } from '@/lib/cn';
export function CardTable({ children, header, footer, hoverable, className }) {
    return (_jsxs(Card, { hoverable: hoverable, className: className, children: [header && _jsx(CardHeader, { children: header }), _jsx(CardBody, { className: "p-0", children: _jsx(Table, { className: "border-0 shadow-none rounded-none", children: children }) }), footer && (_jsx("div", { className: cn('border-t border-slate-100 px-4 py-3 dark:border-slate-800'), children: footer }))] }));
}
